export const l_ELEVATION = 0;
export const l_COLOR = 1;
export const EMPTY_TEXTURE_ZOOM = -1;



// WEBPACK FOOTER //
// ./src/Renderer/LayeredMaterialConstants.js